import { render, staticRenderFns } from "./UnidadEnTaller.vue?vue&type=template&id=51976792&"
import script from "./UnidadEnTaller.vue?vue&type=script&lang=js&"
export * from "./UnidadEnTaller.vue?vue&type=script&lang=js&"
import style0 from "./UnidadEnTaller.vue?vue&type=style&index=0&id=51976792&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports